import {
  POSTCODE,
} from 'jl-design-system/form/fields';

import findIndex from 'lodash/findIndex';

export default function makePostcodeOptional(addressFields) {
  const postcodeFieldIndex = findIndex(addressFields, { id: POSTCODE.id });
  const postcodeField = addressFields[postcodeFieldIndex];

  if (postcodeField) {
    const newField = {
      ...POSTCODE,
      required: false,
    };

    addressFields.splice(postcodeFieldIndex, 1, newField);
  }
}
